<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="ModalProfile"
    title="Edit Profile"
    submit-name="Save changes"
    disable-tabindex
    full-height
    @submit="submit"
  >
    <div class="ProfileBlock">
      <h2 class="ProfileBlock-title">Description</h2>
      <lm-editor v-model="description" type="profile"> </lm-editor>
    </div>

    <div class="ProfileBlock">
      <h2 class="ProfileBlock-title">Motivation</h2>
      <lm-editor v-model="motivation" type="profile"> </lm-editor>
    </div>

    <div class="ProfileBlock">
      <h2 class="ProfileBlock-title">Strategic resources</h2>
      <lm-editor v-model="strategicResources" type="profile"> </lm-editor>
    </div>

    <div class="ProfileBlock">
      <h2 class="ProfileBlock-title">Potential actions</h2>
      <lm-editor v-model="potentialActions" type="profile"> </lm-editor>
    </div>

    <div class="ProfileBlock">
      <h2 class="ProfileBlock-title">Profiling indicators</h2>
      <lm-editor v-model="profilingIndicators" type="profile"> </lm-editor>
    </div>

    <div class="ProfileBlock">
      <h2 class="ProfileBlock-title">Information sources</h2>
      <lm-editor v-model="informationSources" type="profile"> </lm-editor>
    </div>
  </form-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import LmEditor from '@/components/form/LmEditor'

export default {
  name: 'ModalActorProfile',
  components: {
    LmEditor,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.ACTOR_PROFILE,
      modalRef: null,
      bounds: '.ModalProfile',
      dataHasChanged: true,
      description: '',
      motivation: '',
      strategicResources: '',
      potentialActions: '',
      profilingIndicators: '',
      informationSources: ''
    }
  },
  computed: {
    ...mapGetters(['selectedActor'])
  },
  watch: {
    selectedActor() {
      this.updateInputData()
      this.scrollToTop()
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.updateInputData()
    this.scrollToTop()
  },
  methods: {
    updateInputData() {
      if (this.selectedActor && this.selectedActor.profile) {
        let p = this.selectedActor.profile
        this.description = p.description || ''
        this.motivation = p.motivation || ''
        this.strategicResources = p.strategicResources || ''
        this.potentialActions = p.potentialActions || ''
        this.profilingIndicators = p.profilingIndicators || ''
        this.informationSources = p.informationSources || ''
      }
    },
    scrollToTop() {
      this.$nextTick(() => {
        // Scroll to top
        const e = document.querySelector('.Modal-body')
        e.scrollTop = 0
      })
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (this.dataHasChanged) {
        // Call API
        let payload = {
          description: this.description,
          motivation: this.motivation,
          strategicResources: this.strategicResources,
          potentialActions: this.potentialActions,
          profilingIndicators: this.profilingIndicators,
          informationSources: this.informationSources
        }
        this.$store
          .dispatch('updateProfile', payload)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    }
  }
}
</script>

<style>
.ModalProfile {
  .ProfileBlock {
    margin-bottom: 40px;
    &-title {
      margin-bottom: 15px;
      font-size: 14px;
      text-transform: uppercase;
    }
  }
}
</style>
